
import { 
  DriverSalaryAdjustmentsInfoItem,
  DriverSalaryAdjustmentsItem
} from "../../types"
import { ApiDriverSalaryAdjustments } from "services";
import { 
  driverSalaryAdjustmentsCreate,
  driverSalaryAdjustmentsDelete,
  driverSalaryAdjustmentsDetail,
  driverSalaryAdjustmentsEdit,
  driverSalaryAdjustmentsInfo
} from "../../actions";
import { makeRequestWithSpinner } from "worker";
import { ActionPromise } from "bus/rootActions";
import { PayloadRequest } from "types/requestTypes";

export function* fetchDriverSalaryAdjustmentsWorker (action: ActionPromise<DriverSalaryAdjustmentsItem, PayloadRequest>): Generator {
    try {
        const options = {
            fetcher: ApiDriverSalaryAdjustments.getDriverSalaryAdjustments,
            startFetching: driverSalaryAdjustmentsDetail.start,
            stopFetching: driverSalaryAdjustmentsDetail.stop,
            fill: driverSalaryAdjustmentsDetail.fill,
            setErrorAction: driverSalaryAdjustmentsDetail.error,
            fetcherParam: action.payload
        }

        const result = yield makeRequestWithSpinner<DriverSalaryAdjustmentsItem, PayloadRequest>(options);
        yield action.resolve(result as DriverSalaryAdjustmentsItem);
    } catch(e) {
        
    }
}


export function* fetchDriverSalaryAdjustmentsWorkerInfo (action: ActionPromise<DriverSalaryAdjustmentsInfoItem, PayloadRequest>): Generator {
  try {
      const options = {
          fetcher: ApiDriverSalaryAdjustments.getDriverSalaryAdjustmentsInfo,
          startFetching: driverSalaryAdjustmentsInfo.start,
          stopFetching: driverSalaryAdjustmentsInfo.stop,
          fill: driverSalaryAdjustmentsInfo.fill,
          setErrorAction: driverSalaryAdjustmentsInfo.error,
          fetcherParam: action.payload
      }

      const result = yield makeRequestWithSpinner<DriverSalaryAdjustmentsInfoItem, PayloadRequest>(options);
      yield action.resolve(result as DriverSalaryAdjustmentsInfoItem);
  } catch(e) {
      
  }
}


export function* fetchDriverSalaryAdjustmentsWorkerCreate (action: ActionPromise<void, DriverSalaryAdjustmentsItem>): Generator {
  try {
      const options = {
          fetcher: ApiDriverSalaryAdjustments.createDriverSalaryAdjustments,
          startFetching: driverSalaryAdjustmentsCreate.start,
          stopFetching: driverSalaryAdjustmentsCreate.stop,
          fill: driverSalaryAdjustmentsCreate.fill,
          setErrorAction: driverSalaryAdjustmentsCreate.error,
          fetcherParam: action.payload
      }

      yield makeRequestWithSpinner<void, DriverSalaryAdjustmentsItem>(options);
      yield action.resolve();
  } catch(e) {
      
  }
}

export function* fetchDriverSalaryAdjustmentsWorkerEdit (action: ActionPromise<void, DriverSalaryAdjustmentsItem>): Generator {
  try {
      const options = {
          fetcher: ApiDriverSalaryAdjustments.editDriverSalaryAdjustments,
          startFetching: driverSalaryAdjustmentsEdit.start,
          stopFetching: driverSalaryAdjustmentsEdit.stop,
          fill: driverSalaryAdjustmentsEdit.fill,
          setErrorAction: driverSalaryAdjustmentsEdit.error,
          fetcherParam: action.payload
      }

      yield makeRequestWithSpinner<void, DriverSalaryAdjustmentsItem>(options);
      yield action.resolve();
  } catch(e) {
      
  }
}


export function* fetchDriverSalaryAdjustmentsWorkerDelete (action: ActionPromise<void, PayloadRequest>): Generator {
  try {
      const options = {
          fetcher: ApiDriverSalaryAdjustments.deleteDriverSalaryAdjustments,
          startFetching: driverSalaryAdjustmentsDelete.start,
          stopFetching: driverSalaryAdjustmentsDelete.stop,
          fill: driverSalaryAdjustmentsDelete.fill,
          setErrorAction: driverSalaryAdjustmentsDelete.error,
          fetcherParam: action.payload
      }

      yield makeRequestWithSpinner<void, PayloadRequest>(options);
      yield action.resolve();
  } catch(e) {
      
  }
}